// @flow
import Properties from "../../../Properties";
import { getInit, postInit, putInit, graphQLInit } from "../../global/types/constants";
import type { DispatchType } from "../../global/types/redux";
import { CompanyNode, ProjectNode } from "../../account/types/GraphQlNodes";
import { apiFailCallbackHandle } from "../../account/containers/ErrosDisplay";
import { ADMIN_UPDATE_RESELLER_LIST, ADMIN_UPDATE_RESELLER_DETAIL } from "../../global/actions/actionNames";

const root = Properties.api_root;

export const setResellerCompany = (reseller: Object) => ({
  type: ADMIN_UPDATE_RESELLER_LIST,
  reseller
});

const updateResellerDetail = (resellerId: string, fieldName: string, value: string) => ({
  type: ADMIN_UPDATE_RESELLER_DETAIL,
  resellerId: resellerId,
  fieldName: fieldName,
  value: value
});

export const fetchResellerList = () => (dispatch: DispatchType) => {
  const graphQl = `
  {
    resellers { ${CompanyNode} }
  }
  `;
  return fetch(`${root}/api/v2/company/graphql`, graphQLInit(graphQl))
    .then(response => response.json())
    .then(json => {
      if(json.data.resellers.length === 0){
        dispatch(setResellerCompany(null));
      }
      else {
        json.data.resellers.forEach( reseller => {
          dispatch(setResellerCompany(reseller));
        });
      }
    });
};

export function confirmAuthority(companyid: string, field: string, status: string, doneBack: Function, failBack: Function) {
  let formData = new FormData();
  formData.append("status", status);
  return (dispatch: any) => {
    fetch(root + "/api/v2/company/resellers/" + companyid + "/confirm", putInit(formData))
      .then(response => response.json())
      .then(function (json) {
        if (json.errors) {
          failBack && failBack(apiFailCallbackHandle(json.errors));
        }
        else {
          dispatch(updateResellerDetail(companyid, field, status));
          doneBack && doneBack(companyid);
        }
      })
      .catch(err => {
        failBack && failBack(apiFailCallbackHandle(err.message));
      });
  };
}

